import React, { Component } from "react"
import PropTypes from "prop-types"
import {
  MyMazdaDeactivateAccountFlow,
  MyMazdaAccountDetails
} from "containers"
import { Section, H3, A, FormGroup, Space } from "AtomicComponents"

class MyMazdaManageAccountBlock extends Component {
  constructor() {
    super()
    this.state = {
      showDeactivateAccountFlow: false
    }
  }
  render() {
    const { deactivateAccount, ...props } = this.props
    const { showDeactivateAccountFlow } = this.state
    return (
      <Section padding backgroundColor="#FFFFFF">
        <FormGroup>
          <H3 withDetails>Manage account</H3>
          <MyMazdaAccountDetails {...props} />
          <Space />
          <Space />
          <div style={{ textAlign: "left" }}>
            <A
              styleName="black"
              onClick={() => this.setState({ showDeactivateAccountFlow: true })}
            >
              {deactivateAccount.startDeactivateFlowButton}
            </A>
          </div>
          {showDeactivateAccountFlow && (
            <MyMazdaDeactivateAccountFlow
              onClose={() => this.setState({ showDeactivateAccountFlow: false })}
              {...deactivateAccount} />
          )}
        </FormGroup>
      </Section>
    )
  }
}

MyMazdaManageAccountBlock.propTypes = {
  deactivateAccount: PropTypes.shape({
    deactivateAccountEndpoint: PropTypes.string,
    deactivateAccountHeading: PropTypes.string,
    deactivateAccountDescription: PropTypes.string,
    deactivateAccountButton: PropTypes.string,
    cancelDeactivateAccountButton: PropTypes.string
  }),
  resendEmailEndpoint: PropTypes.string,
  emailPendingApproval: PropTypes.bool,
  changeEmailDescription: PropTypes.string,
  changeEmailEndpoint: PropTypes.string,
  changePasswordEndpoint: PropTypes.string
}

MyMazdaManageAccountBlock.defaultProps = {
  deactivateAccount: {
    deactivateAccountEndpoint: "/api/mymazda/Customer",
    startDeactivateFlowButton: "Deactivate account",
    deactivateAccountHeading: "Deactivate your account",
    deactivateAccountDescription:
      "To deactivate your MyMazda account, please provide your password and click the button below, which will end your session. To reactivate your account, you’ll need to register again.",
    deactivateAccountButton: "Yes, deactivate my account",
    cancelDeactivateAccountButton: "Cancel"
  },
  emailPendingApproval: false,
  changeEmailEndpoint: "/api/mymazda/VerifyEmail",
  resendEmailEndpoint: "/api/mymazda/ResendVerifyEmail",
  changeEmailDescription:
    "To change your email address, you'll be sent a confirmation link to your new email address, and your old email address."
}

export default MyMazdaManageAccountBlock



// WEBPACK FOOTER //
// ./src/blocks/mymazda/manage-account/index.jsx